__turbopack_context__.v({
  "icon": "item1-module-scss-module__Ifs9tG__icon",
  "icontext": "item1-module-scss-module__Ifs9tG__icontext",
  "item1": "item1-module-scss-module__Ifs9tG__item1",
  "text": "item1-module-scss-module__Ifs9tG__text",
  "title": "item1-module-scss-module__Ifs9tG__title",
});
